
import { defineComponent } from 'vue'
import Button from '@/components/Button.vue'
import Box from '@/components/Box.vue'
import BgBlur from '@/components/BgBlur.vue'
import LinkArrow from '@/components/LinkArrow.vue'
import Modal from '@/components/Modal.vue'
import Selectel from '@/components/Selectel.vue'
import Share from '@/components/Share.vue'
import LinkIcon from '@/components/LinkIcon.vue'

export default defineComponent({
  name: 'Home',
  components: {
    'tp-box': Box,
    'tp-button': Button,
    'tp-background-blur': BgBlur,
    'tp-link-arrow': LinkArrow,
    'tp-modal': Modal,
    'tp-share': Share,
    selectel: Selectel,
    'tp-link-icon': LinkIcon
  },
  data: function () {
    return {
      showModal: false,
      targetTitle: '',
      level: 0,
      isSend: false,
      isValid: false,
      showErrorName: false,
      showErrorEmail: false,
      showErrorPhone: false,
      agreeTerm: false,
      agreeTermError: false,
      email: '',
      name:'',
      phone: '',
      statusOK: false,
      sending: false,
      isConf: ''
    }
  },
  methods: {
    showModalDialog() {
      this.showModal = true
    },
    sendEmail() {
      if (this.sending === true) {
        return
      }

      this.isValid = true
      this.showErrorEmail = false
      this.showErrorPhone = false
      this.showErrorName  = false
      this.agreeTermError = false

      const emailReg =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (this.email === '' || !emailReg.test(this.email)) {
        this.isValid = false
        this.showErrorEmail = true
      }

      if (this.name === '') {
        this.isValid = false
        this.showErrorName = true
      }

      const phoneReg = /^(\d){1,26}$/g

      if (this.phone === '' || !phoneReg.test(this.phone)) {
        this.isValid = false
        this.showErrorPhone = true
      }

      if (this.agreeTerm !== true) {
        this.isValid = false
        this.agreeTermError = true
      }

      if (this.isValid === false) {
        return
      }

      let data = {
        email: this.email,
        name: this.name,
        phone: this.phone,
        target: this.targetTitle,
        level: this.level,
        time: this.$store.getters.isGameTime || 0
      }
      
      this.sending = true
      fetch('/wp-json/api/special/2048', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          if (data.status === 200) {
            this.showModal = false
            this.isSend = true
            this.statusOK = true
            localStorage.setItem('tproger2048', '1')

            //@ts-ignore
            if (window.successNotyf) {
              //@ts-ignore
              window.successNotyf('Заявка успешно отправлена')
            }

            //@ts-ignore
            if (window.ta) {
              //@ts-ignore
              ta('specials.2048.shareInfo', 1)
            }

            this.sending = false
          }
        })
        .catch((error) => {
          //@ts-ignore
          if (window.errorNotyf) {
            //@ts-ignore
            window.errorNotyf('Ошибка отправки, попробуйте еще')
          }

          this.sending = false
        })
    },
    restart() {
      this.$store.dispatch('setGameStatus', true)
      this.$router.push('/game')
    },
  },
  computed: {
    agreeTermClass() {
      let classes = 'terms-label'
      if (this.agreeTermError === true) {
        classes = classes + ' terms-label__error'
      }
      return classes
    },
  },
  mounted() {
    if (this.$store.getters.isWin === false) {
      this.$router.push('/')
    }

    //@ts-ignore
    if (window.game2048) {
      //@ts-ignore
      if (window.game2048.conf && window.game2048.conf !== '') {
        //@ts-ignore
        this.isConf = window.game2048.conf
      }
    }

    //@ts-ignore
    if (window.ta) {
      //@ts-ignore
      ta('specials.2048.victory', 1)
    }

    const target = this.$store.getters.target || null
    if (target) {
      this.targetTitle = target.title || ''
      this.level = target.level || 1
    }

    const isSend = localStorage.getItem('tproger2048')
    if (isSend) {
      this.isSend = true
    }

    const gameTime = this.$store.getters.isGameTime || 0
    console.log('вы играли ', gameTime, ' c')
  },
})
